import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie"; 
import { Helmet } from "react-helmet";
import './select-company.css';
import { Toast } from '../components_root/ToastContext';
import { MdAnalytics, MdCheckBox, MdCheckBoxOutlineBlank, MdSearch } from "react-icons/md";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Select_company() {
    const Aooz = "https://firebasestorage.googleapis.com/v0/b/aooz-in.firebasestorage.app/o/icons%2Flogo.png?alt=media&token=33169cf7-2966-4b54-a30f-57aad5b5b879";
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companyData, setCompanyData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [userlogin, setuserlogin] = useState(false);
    const [accountguid, setaccountguid] = useState('');
    useEffect(() => {
        const sessiontoken = Cookies.get("sessiontoken");
        const gid = Cookies.get("guid");

        // ❌ Not logged in → redirect
        if (!sessiontoken || !gid) {
            setuserlogin(false);
        } else {
            setuserlogin(true);
            setaccountguid(gid);
        }

        // ✅ Logged in → set guid

    }, [navigate]);
    useEffect(() => {
        const fetchCompanies = async () => {
            // 🔒 Safety check
            if (!accountguid || userlogin === false) {
                setIsLoading(false);
                // navigate("/pricing");
                return;
            }

            setIsLoading(true);

            try {
                const q = collection(
                    db,
                    "accounts",
                    accountguid,
                    "accounts_authority"
                );

                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    console.log("No companies found");
                    setCompanyData([]);
                    return;
                }

                const docs = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setCompanyData(docs);
            } catch (err) {
                console.error("Error fetching companies:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCompanies();
    }, [accountguid, userlogin]);

    return (
        <div>
            <div className="container_roots">
                <div className="container_size_info">
                    <div className="text-h1 bold">Hello</div>
                    <div className="text-h1">Welcome back to aooz-{Cookies.get("select_company_uid")}</div>
                    <div className="border rounded p-2">
                        <table >

                            <tr>
                                <td  ><div className="text-h2">Ads that educate and inform</div></td>
                            </tr>
                            <tr>
                                <td  ><div className="text-h3 text-off">Discover ads that teach you something valuable before promoting a product</div></td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <div className="rounded">
                        <table>
                            <tr>
                                <td width={30} >
                                    <MdSearch className="icon" />
                                </td>
                                <input type="text" className="border-none p-2" placeholder="Search company..." />
                            </tr>
                        </table>
                    </div>
                    {companyData && companyData.length > 0 ? (
                        companyData.map((row) => (
                            <div
                                className={`ui-items b-1 rounded flex m-1 ${row.companyuid === Cookies.get("select_company_uid")
                                    ? "items-back-fill"
                                    : "items-back"
                                    }`}
                                key={row.uid}
                            >
                                <img className="icon_img rounded"
                                    src={row.logo_url || Aooz}
                                    alt={`${row.company || "Company"} logo`} 
                                />

                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="fcap text-h1 bold">
                                                    {row.company || "Unnamed Company"}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="text-h4 text-off">ID:
                                                    {row.companyuid || "No UID"}
                                                </div>
                                            </td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                                {row.companyuid === Cookies.get("select_company_uid") ? (<div className="p-33"

                                    onClick={() => {

                                        const hostname = window.location.hostname;
                                        const isHttps = window.location.protocol === "https:";
                                        const isLocalhost =
                                            hostname === "localhost" || hostname === "127.0.0.1";

                                        const cookieOptions = {
                                            expires: 1,
                                            path: "/",
                                            secure: isHttps,
                                            sameSite: isHttps ? "None" : "Lax",
                                            ...(isHttps && !isLocalhost && { domain: ".aooz.in" })
                                        };

                                        Cookies.remove("select_company_uid", { path: "/" });
                                        Cookies.set(
                                            "select_company_uid",
                                            row.companyuid,
                                            cookieOptions
                                        );


                                        Toastshow("Company switched successfully!");
                                        navigate(`/`);

                                    }}
                                >     <MdCheckBox className="icon green" />

                                </div>) : (
                                    <div>
                                        <div className="p-33"

                                            onClick={() => {
                                                 const hostname = window.location.hostname;
                                        const isHttps = window.location.protocol === "https:";
                                        const isLocalhost =
                                            hostname === "localhost" || hostname === "127.0.0.1";

                                        const cookieOptions = {
                                            expires: 1,
                                            path: "/",
                                            secure: isHttps,
                                            sameSite: isHttps ? "None" : "Lax",
                                            ...(isHttps && !isLocalhost && { domain: ".aooz.in" })
                                        };

                                        Cookies.remove("select_company_uid", { path: "/" });
                                        Cookies.set(
                                            "select_company_uid",
                                            row.companyuid,
                                            cookieOptions
                                        );

                                                Toastshow("Company switched successfully!");
                                                navigate(`/`);

                                            }}
                                        >
                                            <MdCheckBoxOutlineBlank className="icon" />
                                        </div>
                                    </div>
                                )}

                            </div>
                        ))
                    ) : (
                        <div>No companies found.</div>
                    )}
                </div>
            </div>
        </div>
    );
}
